import { useEffect, useCallback } from 'react';
import { Typography, Box, Container, Paper } from '@mui/material';
import SegmentedControls from '../../components/common/SegmentedControls.component';
import Loading from '../../components/common/Loading.component';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import ListView from '../../views/List.view';
import ToolbarComponent from '../../components/toolbar/Toolbar.component';
import _ from 'lodash';
import { useState } from 'react';
import CalendarScheduler from '../../components/calendarTimeline/CalendarScheduler.component';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);

const BookingsPage = ({
  module: { query, tag, views, search, list, filter, calendar },
}) => {
  const { selector } = calendar;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { jwt } = useSelector((state) => state.login);
  const {
    data: { loading },
    view: { value: view },
    filter: { value },
  } = useSelector((state) => state[tag]);

  const { sort: sortCalendar } = useSelector(selector.data);
  const _query = useSelector(query.all.selector);
  const userAuth = useSelector((state) => state.login?.user);
  const { from } = useSelector((state) => state.year);
  const [success, setSuccess] = useState(false);

  useEffect(() => {
    const fetchData = () => {
      if (
        userAuth.permissions[_.toUpper(tag)]?.READ === 'true' &&
        view?.value === 'list'
      ) {
        dispatch(
          query.all.action({
            settings: query.all.settings,
            token: jwt,
            query: { ..._query, populate: query.all.populate },
          })
        );
      } else {
        dispatch(
          query.all.action({
            settings: query.all.settings,
            token: jwt,
            query: {
              ..._query,
              sort: [`${sortCalendar.by}:${sortCalendar.direction}`],
              populate: query.all.populate,
            },
          })
        );
      }
    };

    fetchData();

    const interval = setInterval(fetchData, 60_000);

    return () => clearInterval(interval);
  }, [
    _query,
    jwt,
    userAuth,
    view,
    sortCalendar,
    tag,
    dispatch,
    success,
    query,
  ]);

  const onClick = useCallback(
    (item) => navigate(`${item.id}`, { state: { from: tag } }),
    [navigate, tag]
  );

  return (
    <Container disableGutters={true} maxWidth={false} sx={{ height: '100%' }}>
      <Box display={'flex'} justifyContent='space-between' padding={3}>
        <Typography variant='h4' sx={{ fontWeight: 'bold' }}>
          Bookings
        </Typography>
        {userAuth.permissions[_.toUpper(tag)]?.READ_LIST === 'true' &&
          userAuth.permissions[_.toUpper(tag)]?.READ_CALENDAR === 'true' && (
            <SegmentedControls tag='booking' views={views} />
          )}
      </Box>
      <Paper variant='outlined'>
        <ToolbarComponent
          tag='booking'
          search={search}
          add={list.add}
          filter={filter}
          list={list}
        />
        {loading && <Loading />}
        {userAuth.permissions[_.toUpper(tag)]?.READ === 'true' && (
          <Box padding={2}>
            {userAuth.permissions[_.toUpper(tag)]?.READ_CALENDAR === 'true' &&
              view.value === 'calendar' && (
                <CalendarScheduler
                  startDate={value?.start_date || `${dayjs(from).year()}-01-01`}
                  endDate={
                    value?.end_date
                      ? value?.end_date
                      : value?.start_date
                        ? value?.start_date
                        : `${dayjs(from).year()}-12-31`
                  }
                  onClick={onClick}
                  onSuccess={setSuccess}
                  calendar={calendar}
                />
              )}
            {userAuth.permissions[_.toUpper(tag)]?.READ_LIST === 'true' &&
              (view.value === 'list' ||
                userAuth.permissions[_.toUpper(tag)]?.READ_CALENDAR ===
                'false') && <ListView list={list} onClick={onClick} />}
          </Box>
        )}
      </Paper>
    </Container>
  );
};

export default BookingsPage;
